import { graphql } from "gql.tada";

export const GetProductState = graphql(`
  query getProductState($input: GetProductStateInput!) {
    getProductState(input: $input) {
      result {
        product {
          id
          orderCode {
            parts {
              options {
                signatures {
                  description
                  value
                  range
                  isDefault
                  state
                  key
                  title
                  presentation
                }
                currentSignature {
                  description
                  value
                  range
                  isDefault
                  state
                  key
                  title
                  presentation
                }
                state
                range {
                  min
                  max
                }
                type
                separator
                key
                title
                presentation
              }
              state
              key
              title
              presentation
            }
            key
            title
            presentation
          }
          selectedAccessories {
            seriesId
            pimId
            seriesName
            currentPresentation
            currentStrategyId
            ordercode {
              parts {
                options {
                  signatures {
                    description
                    value
                    range
                    isDefault
                    state
                    key
                    title
                    presentation
                  }
                  currentSignature {
                    description
                    value
                    range
                    isDefault
                    state
                    key
                    title
                    presentation
                  }
                  state
                  range {
                    min
                    max
                  }
                  type
                  separator
                  key
                  title
                  presentation
                }
                state
                key
                title
                presentation
              }
              key
              title
              presentation
            }
            accessoryId
            accessoryGroupId
            infoText
            optionStates {
              partKey
              optionKey
              signatureKey
              signaturePresentation
              parentRef {
                partKey
                optionKey
              }
              isSizePart
              signatureValue

              separator
            }
            lastChange {
              partKey
              optionKey
              signatureKey
              parentRef {
                partKey
                optionKey
              }
              isSizePart
              signatureValue

              separator
            }
          }
          accessoryGroups {
            id
            name
            accessories {
              seriesId
              pimId
              serieAlias
              seriesName
              currentPresentation
              ordercode {
                parts {
                  options {
                    signatures {
                      description
                      value
                      range
                      isDefault
                      state
                      key
                      title
                      presentation
                    }
                    currentSignature {
                      description
                      value
                      range
                      isDefault
                      state
                      key
                      title
                      presentation
                    }
                    state
                    range {
                      min
                      max
                    }
                    type
                    separator
                    key
                    title
                    presentation
                  }
                  state
                  key
                  title
                  presentation
                }
                key
                title
                presentation
              }
              accessoryId
              accessoryGroupId
              infoText
              optionStates {
                partKey
                optionKey
                signatureKey
                signaturePresentation
                parentRef {
                  partKey
                  optionKey
                }
                isSizePart
                signatureValue

                separator
              }
              lastChange {
                partKey
                optionKey
                signatureKey
                parentRef {
                  partKey
                  optionKey
                }
                isSizePart
                signatureValue

                separator
              }
            }
          }
          accessoryInfo {
            accessoryId
            accessoryGroupId
            parent {
              seriesId
              state {
                currentStrategyId
                currentStrategyName
                orderCodeState {
                  optionStates {
                    isSizePart
                    optionKey
                    partKey
                    separator
                    signatureKey
                    signatureValue
                    signaturePresentation
                    parentRef {
                      partKey
                      optionKey
                    }
                  }
                  lastChange {
                    isSizePart
                    optionKey
                    partKey
                    separator
                    signatureKey
                    signatureValue
                    signaturePresentation
                    parentRef {
                      partKey
                      optionKey
                    }
                  }
                }
                propertyStates {
                  id
                  value
                }
              }
            }
          }
          inputs {
            presentation
            properties {
              id
              symbol
              presentation
              description
              displayUnit
              displayValue
              unit
              precision
              value
              valueMin
              valueMax
              valueZeroAllowed
              valueMinInclusive
              valueMaxInclusive
              values
              validationType
              validationMessage
              bomRelevant
            }
          }
          outputs {
            presentation
            properties {
              id
              symbol
              presentation
              description
              displayUnit
              displayValue
              unit
              precision
              value
              valueMin
              valueMax
              valueZeroAllowed
              valueMinInclusive
              valueMaxInclusive
              values
              validationType
              validationMessage
              bomRelevant
            }
          }
          outputsAcoustic {
            presentation
            properties {
              id
              symbol
              presentation
              description
              displayUnit
              displayValue
              unit
              precision
              value
              valueMin
              valueMax
              valueZeroAllowed
              valueMinInclusive
              valueMaxInclusive
              values
              validationType
              validationMessage
              bomRelevant
            }
          }
          availableStrategies {
            id
            presentation
          }
          currentStrategyId
          productType
          pluginName
          serie
          listViewConfiguration {
            columnTitles {
              key
              title
              subTitles {
                key
                title
                subTitles {
                  key
                  title
                  subTitles {
                    key
                    title
                  }
                }
              }
            }
            iterableParts {
              partKey
              options {
                optionKey
              }
            }
            targetPropertiesTitle
            targetProperties {
              id
              name
              valueMin
              valueMax
              unit
              defaultValue
              ignorable
            }
            accessories {
              title
              groups {
                title
                groupControlType
                controls {
                  id
                  title
                  keyPresentation
                  boolValue
                  enabledBy
                  enabled
                }
              }
            }
            attachments {
              title
              groups {
                title
                groupControlType
                controls {
                  id
                  title
                  boolValue
                  enabledBy
                  enabled
                  keyPresentation
                }
              }
            }
          }
        }
        productImageList {
          productImages {
            pimId
            text
            isReportImage
            typ
          }
        }
        specificationText {
          text
        }
      }
      errorCode
      errorMessage
      epfVersion {
        major
        minor
        revision
        build
      }
    }
  }
`);

export const ProductPriceListQry = graphql(`
  query productPriceList($input: ProductListInput!) {
    productPriceList(input: $input) {
      includesPriceOnRequest
      description
      products {
        id
        priceGroup
        fullPriceGroup
        priceListDesc
        unitPrice {
          type
          currencyCode
          centAmount
          fractionDigits
          preciseAmount
          __typename
        }
        totalPrice {
          type
          currencyCode
          centAmount
          fractionDigits
          preciseAmount
          __typename
        }
        __typename
      }
      productsPrice {
        type
        currencyCode
        centAmount
        fractionDigits
        __typename
      }
      __typename
    }
  }
`);

export const UserProductListQry = graphql(`
  query productList($input: ProductListInput!) {
    productList(input: $input) {
      limit
      page
      pages
      productsCount
      products {
        id
        title
        kind
        quantity
        orderCode
        presentation
      }
      productsPrice {
        type
        currencyCode
        centAmount
        preciseAmount
        fractionDigits
      }
      includesDummyProduct
      includesPriceOnRequest
    }
  }
`);

export const ProductListQuery = graphql(`
  query seriesNodes($input: GetSeriesNodesInput!) {
    seriesNodes(input: $input)
  }
`);

export const DummyProductSeriesQuery = graphql(`
  query dummySeries($input: GetDummySeriesInput!) {
    dummySeries(input: $input) {
      message
      result {
        name
        pimId
        seriesId
        seriesAlias
      }
    }
  }
`);

export const getLCAProductReportQry = graphql(`
  query getLCAProductReport($input: GetLCAProductReportInput!) {
    getLCAProductReport(input: $input) {
      message
      jobId
      status
      url
    }
  }
`);
